/*
  Farbgalerie: Nach einem Variantenwechsel lädt Dawn die Sektion mit ?variant=ID nach (renderProductInfo) und meldet
  das Ergebnis über PUB_SUB_EVENTS.variantChange. Hat sich der Farbblock geändert (data-farbblock), werden Galerie,
  Vorschaubilder und Lightbox aus der neuen Sektion übernommen. Gleiche Farbe, andere Größe: nichts passiert.
  Siehe snippets/mil-farbblock.liquid. Ohne jQuery.
*/
(function () {
  if (window.milFarbgalerie) return;
  window.milFarbgalerie = true;

  function tauschen(sectionId, html) {
    var getauscht = false;

    document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]').forEach(function (alt) {
      var neu = html.getElementById(alt.id);
      if (!neu || alt.dataset.farbblock === neu.dataset.farbblock) return;
      // replaceWith übernimmt den Knoten ins Dokument; die Custom Elements (media-gallery, slider-component,
      // mil-galerie, modal-opener, deferred-media) werden dabei neu verbunden und initialisieren sich selbst.
      alt.replaceWith(document.importNode(neu, true));
      getauscht = true;
    });

    var altesModal = document.getElementById('ProductModal-' + sectionId);
    var neuesModal = html.getElementById('ProductModal-' + sectionId);
    if (altesModal && neuesModal && altesModal.dataset.farbblock !== neuesModal.dataset.farbblock) {
      var altInhalt = altesModal.querySelector('.product-media-modal__content');
      var neuInhalt = neuesModal.querySelector('.product-media-modal__content');
      if (altInhalt && neuInhalt) {
        altInhalt.replaceChildren.apply(
          altInhalt,
          Array.prototype.map.call(neuInhalt.childNodes, function (n) {
            return document.importNode(n, true);
          })
        );
        altesModal.dataset.farbblock = neuesModal.dataset.farbblock;
      }
    }

    return getauscht;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      try {
        tauschen(data.sectionId, data.html);
      } catch (e) {
        // Im Fehlerfall bleibt die bisherige Galerie stehen; die Seite funktioniert weiter.
        console.error('Farbgalerie:', e);
      }
    });
  });
})();
